<template lang="pug">
.document-badge-slider(v-if='documents.length > 1')
  button.slider-arrow.slider-arrow--left(
    @click='scrollByAmount(-200)'
    type='button'
    v-if='canScrollLeft'
  )
    icon(name='angle-left')
  .document-badge-selector(@scroll='updateScrollState' ref='scrollContainer')
    button.document-badge(
      :class='{ "document-badge--active": isActive(document) }'
      :key='document.id'
      @click='$emit("select", document)'
      type='button'
      v-for='document in documents'
      v-tooltip:top='document.name'
    )
      icon(name='file')
      span.document-badge-name {{ document.name }}
  button.slider-arrow.slider-arrow--right(
    @click='scrollByAmount(200)'
    type='button'
    v-if='canScrollRight'
  )
    icon(name='angle-right')
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'DocumentBadgeSelector',
  components: {
    Icon,
  },
  props: {
    documents: {
      type: Array,
      required: true,
    },
    selectedDocument: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      canScrollLeft: false,
      canScrollRight: false,
    };
  },
  mounted() {
    this.updateScrollState();
    window.addEventListener('resize', this.updateScrollState);
  },
  updated() {
    this.updateScrollState();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateScrollState);
  },
  methods: {
    isActive(document) {
      return document.id === this.selectedDocument?.id;
    },
    updateScrollState() {
      const el = this.$refs.scrollContainer;
      if (!el) {
        return;
      }
      this.canScrollLeft = el.scrollLeft > 0;
      this.canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
    },
    scrollByAmount(amount) {
      this.$refs.scrollContainer?.scrollBy({
        left: amount,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped lang="stylus">
.document-badge-slider
  display: flex
  align-items: center
  gap: 0.5rem
  margin-bottom: 1.5rem
.slider-arrow
  -webkit-appearance: none
  -moz-appearance: none
  appearance: none
  outline: none
  flex: 0 0 auto
  display: flex
  align-items: center
  justify-content: center
  width: 1.75rem
  height: 1.75rem
  border: 1px solid #CCCCCC
  border-radius: 50%
  background-color: #fff
  color: #19665B
  cursor: pointer
  transition: border-color .15s ease

  &:hover
    border-color: #19665B
.document-badge-selector
  display: flex
  flex-wrap: nowrap
  gap: 0.75rem
  flex: 1 1 auto
  min-width: 0
  overflow-x: auto
  padding-bottom: 0.6rem
  -webkit-overflow-scrolling: touch
  scrollbar-width: thin
  scrollbar-color: #19665B #E7F0EF

  &::-webkit-scrollbar
    height: 6px

  &::-webkit-scrollbar-track
    background-color: #E7F0EF
    border-radius: 10px

  &::-webkit-scrollbar-thumb
    background-color: #19665B
    border-radius: 10px
.document-badge
  -webkit-appearance: none
  -moz-appearance: none
  appearance: none
  outline: none
  flex: 0 0 auto
  display: inline-flex
  align-items: center
  gap: 0.5rem
  padding: 0.55rem 1rem
  background-color: #fff
  background-image: none
  border: 1px solid #CCCCCC
  border-radius: 20px
  font-size: 0.85rem
  color: #495057
  cursor: pointer
  transition: border-color .15s ease, color .15s ease, background-color .15s ease

  &:hover
    border-color: #19665B

  &--active
    border-color: #19665B
    background-color: #E7F0EF
    color: #19665B
    font-weight: 600
.document-badge-name
  max-width: 160px
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
</style>
